<h2 mat-dialog-title>Order Transfer</h2>
<mat-progress-bar mode="indeterminate"
                      *ngIf="loadingIndicator"
    ></mat-progress-bar>
<form [formGroup]="orderTransferForm">
<mat-dialog-content class="mat-typography">
  <div class="row">
      <div class="col-md-12">
        <div class="dx-field">
            <kendo-formfield>
              <kendo-label
                [for]="salesOrderVar"
                text="Sales Order #"
              ></kendo-label>
              <kendo-numerictextbox
                [spinners]="false"
                #salesOrderVar
                id="salesOrderId"
                [format]="'null'"
                [tabIndex]="1"
                class="w-100"
                formControlName="salesOrderId"
                [rangeValidation]="false"
                placeholder="Sales Order #"
                (valueChange)="onChange($event)"
              >
              </kendo-numerictextbox>
              <kendo-formerror
                *ngIf="
                orderTransferForm.get('salesOrderId').errors
                    ?.required
                "
                >value is required</kendo-formerror
              >
            </kendo-formfield>
          </div>
      </div>
      <div class="col-md-12">
        <div class="dx-field">
          <kendo-formfield>
            <kendo-label text="Order Type"></kendo-label>
            <kendo-textbox
              [readonly]="true"
              class="w-100"
              placeholder="Order Type"
              value="{{salesOrderData?.salesOrderTypeName}}"
            >
            </kendo-textbox>
          </kendo-formfield>
        </div>
      </div>
      <div class="col-md-12">
        <div class="dx-field">
          <kendo-formfield>
            <kendo-label text="Customer Name"></kendo-label>
            <kendo-textbox
              [readonly]="true"
              class="w-100"
              placeholder="Customer Name"
              value="{{salesOrderData?.customerName}}"
            >
            </kendo-textbox>
          </kendo-formfield>
        </div>
      </div>
      <div class="col-md-12">
        <div class="dx-field">
            <kendo-formfield>
              <kendo-label
                [for]="fromCompanyBranchId"
                text="Form Company Branch"
              ></kendo-label>
              <kendo-combobox
                [virtual]="true"
                [clearButton]="true"
                [loading]="companyBranchLoading"
                #fromCompanyBranchId
                class="w-100"
                formControlName="fromCompanyBranchId"
                [valuePrimitive]="true"
                [data]="allCompanyBranches"
                [valueField]="'companyBranchId'"
                [readonly]="true"
                [textField]="'companyBranchName'"
                [filterable]="true"
                [kendoDropDownFilter]="{ operator: 'contains' }"
                [suggest]="true"
                placeholder="Form Company Branch"
              >
              </kendo-combobox>
            </kendo-formfield>
        </div>
    </div>
    <div class="col-md-12">
        <div class="dx-field">
            <kendo-formfield>
              <kendo-label
                [for]="toCompanyBranchIdVar"
                text="To Company Branch"
              ></kendo-label>
              <kendo-combobox
                [virtual]="true"
                [clearButton]="true"
                #toCompanyBranchIdVar
                [loading]="companyBranchLoading"
                [tabIndex]="2"
                class="w-100"
                formControlName="toCompanyBranchId"
                [valuePrimitive]="true"
                [data]="allCompanyBranches"
                [valueField]="'companyBranchId'"
                [textField]="'companyBranchName'"
                [filterable]="true"
                [kendoDropDownFilter]="{ operator: 'contains' }"
                [suggest]="true"
                [readonly]="true"
                placeholder="To Company Branch"
                (valueChange)="selectCompanyBranch()"
              >
              </kendo-combobox>
              <kendo-formerror
                *ngIf="
                orderTransferForm.get('toCompanyBranchId').errors
                    ?.required
                "
                >value is required</kendo-formerror
              >
              <kendo-formerror
                *ngIf="
                orderTransferForm.get('toCompanyBranchId').errors
                    ?.isValid"
                >Please select another branch</kendo-formerror
              >
            </kendo-formfield>
        </div>
    </div>
  </div>

  <div class="row mt-3">
      <div class="col-md-12">
          <div class="alert alert-danger" *ngIf="isError">
              {{responseMsg}}
          </div>
          <div class="alert alert-success" *ngIf="isSuccess">
            {{responseMsg}}
        </div>
      </div>
  </div>

</mat-dialog-content>
</form>
<mat-dialog-actions align="end">
  <button  class="mat-raised-button" mat-dialog-close>Cancel</button>
  <button class="mat-raised-button mat-primary" cdkFocusInitial (click)="submitData(orderTransferForm)">Save</button>
</mat-dialog-actions>
